<script>
import ConversationCard from 'dashboard/components/widgets/conversation/ConversationCard.vue';
import { mapGetters } from 'vuex';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import wootConstants from 'dashboard/constants/globals';

export default {
  components: {
    ConversationCard,
    Spinner,
  },
  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
    conversationId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    conversations() {
      return this.$store.getters['contactConversations/getContactConversation'](
        this.contactId
      );
    },
    isCurrentConversation() {
      return conversationId => conversationId === Number(this.conversationId);
    },
    // Another open conversation of the contact, the one the agent may be missing.
    isOtherOpenConversation() {
      return conversation =>
        conversation.status === wootConstants.STATUS_TYPE.OPEN &&
        !this.isCurrentConversation(conversation.id);
    },
    ...mapGetters({
      uiFlags: 'contactConversations/getUIFlags',
    }),
  },
};
</script>

<template>
  <div v-if="!uiFlags.isFetching" class="">
    <div v-if="!conversations.length" class="no-label-message px-4 p-3">
      <span>
        {{ $t('CONTACT_PANEL.CONVERSATIONS.NO_RECORDS_FOUND') }}
      </span>
    </div>
    <div v-else class="contact-conversation--list">
      <ConversationCard
        v-for="conversation in conversations"
        :key="conversation.id"
        :chat="conversation"
        :hide-inbox-name="false"
        hide-thumbnail
        highlight-open
        enable-context-menu
        context-menu-links-only
        class="compact"
        :class="{
          'current-conversation': isCurrentConversation(conversation.id),
          'open-conversation': isOtherOpenConversation(conversation),
        }"
      />
    </div>
  </div>
  <div v-else class="flex items-center justify-center py-5">
    <Spinner />
  </div>
</template>

<style lang="scss" scoped>
.no-label-message {
  @apply text-slate-500 dark:text-slate-400 mb-4;
}

::v-deep .conversation {
  @apply pr-0;

  .conversation--details {
    @apply pl-2;
  }
}

::v-deep .open-conversation {
  @apply bg-n-amber-2 hover:bg-n-amber-3 dark:hover:bg-n-amber-3;
}

::v-deep .current-conversation {
  @apply bg-slate-50 dark:bg-slate-800/50 border-l-2 border-woot-500;

  .conversation {
    @apply bg-transparent;
  }
}
</style>
